<div class="card flex justify-center">
    <p-drawer [(visible)]="visible" [blockScroll]="true" [closable]="closable" [pt]="drawerPT" [position]="position" [header]="header" [style]="{ width: width }" [styleClass]="customClass  + ' dark:gray-900'" (onHide)="onClose()">
        <ng-template #container ></ng-template>
    </p-drawer>
</div>
